import { memo, ReactNode } from "react";
import { clsx } from "clsx";

import { useDevice } from "@/shared/lib/hooks/useDevice";

import cls from "./Title.module.scss";

export enum TitleSize {
  H1 = "HeadingH1",
  H2 = "HeadingH2",
  H3 = "HeadingH3",
}

type TagType = "h1" | "h2" | "h3";

const mapSizeToTag: Record<TitleSize, TagType> = {
  [TitleSize.H1]: "h1",
  [TitleSize.H2]: "h2",
  [TitleSize.H3]: "h3",
};

interface TitleProps {
  children: ReactNode;
  className?: string;
  size?: TitleSize;
}

export const Title = memo((props: TitleProps) => {
  const { children, className, size = TitleSize.H1 } = props;

  const { isMobile } = useDevice();

  const Tag = mapSizeToTag[size];

  const mods = {
    [cls[size]]: true,
    [cls.isMobile]: isMobile,
  };

  return <Tag className={clsx(cls.Title, mods, [className])}>{children}</Tag>;
});
